import singleMode from "./selectBaseSingle";

const year = new Date().getFullYear();
const startYear = year - 99;
const endYear = year - 18;

const years = endYear - startYear;

const items = [];

for (let i = 0; i <= years; i++) {
	items[i] = {
		key: i,
		content: startYear + i,
		value: startYear + i,
	};
}

items.reverse();

export default ({ initial }) => ({
	items,
	...singleMode({ items, initial }),
});
